// extracted by mini-css-extract-plugin
export default {"btn-arrow":"Notification_btn-arrow__ET73-"};